import { render, staticRenderFns } from "./PaginationNavigation.vue?vue&type=template&id=43e21330&scoped=true"
import script from "./PaginationNavigation.vue?vue&type=script&lang=js"
export * from "./PaginationNavigation.vue?vue&type=script&lang=js"
import style0 from "./PaginationNavigation.vue?vue&type=style&index=0&id=43e21330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e21330",
  null
  
)

export default component.exports